document.addEventListener("DOMContentLoaded", function () {
  $(".m-menu__link--parent").click(function (e) {
    e.preventDefault();
    $(this).toggleClass("active");
    $(this).siblings(".m-menu__sublist").slideToggle();
  });

  $(".header__burger").click(function () {
    $(this).hide();
    $(".header__burger-close").show();
    $(".m-menu").addClass("active");
    $(".m-menu").css("top", $("#header").height() - 1);
    // $('body').addClass('muted');
  });
  $(".header__burger-close").click(function () {
    $(this).hide();
    $(".header__burger").show();
    $(".m-menu").removeClass("active");
    // $('body').removeClass('muted');
  });

  $(".f-col__list").slick({
    slidesToShow: 4,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          dots: true,
          // fade: true
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 1,
          dots: true,
          // fade: true
        },
      },
    ],
  });

  $(document).on("click", "[data-quick-add]", (e) => {
    let elem = $(e.target).closest("[data-quick-add]");
    e.preventDefault();
    let id = +elem.attr("data-quick-add");
    $.ajax({
      type: "post",
      url: "/cart/add.js",
      dataType: "json",
      data: {
        id,
        quantity: 1,
      },
      success: (data) => {
        console.log(data);
        $(".js-cart-nav-toggle").click();
      },
    });
  });

  $(".product__tab").click(function () {
    let index = $(this).attr("data-index");
    $(".product__tab").removeClass("active");
    $(".product__tab-content").removeClass("active");
    $(this).addClass("active");
    $(`.product__tab-content[data-index="${index}"]`).addClass("active");
  });

  $(".p-videos__list").slick({
    slidesToShow: 3,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 1,
          fade: true,
          dots: true,
        },
      },
    ],
  });

  $(".p-videos__btn").click(function () {
    $(this).hide();
    $(this).siblings("img").addClass("hidden");
    $(this).siblings("video").addClass("active");
    $(this).siblings("video")[0].play();
  });

  $(".announcement-wrap").slick({
    fade: true,
    autoplay: 3000,
  });

  $("[data-toggle-search]").click(function (e) {
    e.preventDefault();
    $(this).hide();
    $(".header__search-wrap").addClass("active");
    $(".header__search-wrap .search-form__input").focus();
  });

  $(".promo__footer").click(function () {
    $(".promo__popup-wrap").addClass("active");
  });
  $(".promo__popup-close").click(function () {
    $(".promo__popup-wrap").removeClass("active");
  });
  $(".promo__popup-wrap").click(function (e) {
    if (!$(e.target).closest(".promo__popup").length) {
      $(".promo__popup-wrap").removeClass("active");
    }
  });

  if ($("[data-marquee]").length) {
    let x = 0;

    function animateMarquee() {
      x -= 0.5;
      $("[data-marquee]").css("transform", `translateX(${x}px)`);
      if (x < -2000) x = 0; // Reset position
      requestAnimationFrame(animateMarquee);
    }

    requestAnimationFrame(animateMarquee);


   function dataMarqueeItem(){
     $("[data-marquee]").each(function () {
       const $this = $(this);
       const items = $this.find("[data-marquee-item]");
       if (items.length < 20)  items.eq(0).clone().appendTo($this);
       requestAnimationFrame(dataMarqueeItem)
     });
   }
    requestAnimationFrame(dataMarqueeItem)
  }

  $(".faq__item-title").click(function () {
    $(this).siblings(".faq__item-text").slideToggle();
    $(this).toggleClass("active");
  });

  $(".promo__wrap").slick({
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    infinite: true,
  });
  $(".s-compare__item-head").click(function () {
    $(this).siblings(".s-compare__item-wrap").slideToggle();
    $(this).closest(".s-compare__item").toggleClass("active");
  });

  const tabsCollsSections = document.querySelectorAll(".tabs-colls__wrap");

  tabsCollsSections.forEach((tabsColls) => {
    console.log(5)
    if (tabsColls) {
      const $tabsColls = $(tabsColls);
      const tabs = tabsColls.querySelectorAll(".tabs-colls__tab");
      const contents = tabsColls.querySelectorAll(".tabs-colls__content");

      // Initialize slick for the first content
      $tabsColls.find(".tabs-colls__content.active .tabs-colls__slider").slick({
        slidesToShow: 1,
        variableWidth: true,
        arrow: true,
        dots: true,
        responsive: [
          {
            breakpoint: 500,
            settings: {
                slidesToShow: 1.2,
               variableWidth: false,
              centerMode: true
              },
            },
        ]
        // adaptiveHeight: true
      });

      const tabsLine = tabsColls.querySelector(".tabs-colls__tabs-line");
      if (tabsLine) {
        const activeTab = tabs[0];
        tabsLine.style.width = activeTab.offsetWidth + "px";
        tabsLine.style.transform = `translateX(${activeTab.offsetLeft}px)`;
      }

      tabs.forEach((tab) => {
        tab.addEventListener("click", () => {
          const tabNumber = tab.dataset.tab;
          $tabsColls
            .find(".tabs-colls__slider.slick-initialized")
            .slick("unslick");

          tabs.forEach((tab) => tab.classList.remove("active"));
          contents.forEach((content) => content.classList.remove("active"));

          tab.classList.add("active");
          contents.forEach((content) => {
            if (content.dataset.tab === tabNumber) {
              content.classList.add("active");
            }
          });

          // Move the tabs line to the active tab
          const tabsLine = tabsColls.querySelector(".tabs-colls__tabs-line");
          if (tabsLine) {
            tabsLine.style.width = tab.offsetWidth + "px";
            tabsLine.style.transform = `translateX(${tab.offsetLeft}px)`;
          }

          // Reinitialize slick
            $tabsColls
              .find(".tabs-colls__content.active .tabs-colls__slider")
              .slick({
                slidesToShow: 1,
                variableWidth: true,
                arrow: true,
                dots: true,
                 responsive: [
                  {
                    breakpoint: 500,
                    settings: {
                      slidesToShow: 1.2,
                       variableWidth: false,
                      centerMode:true
                    },
                  },
                ]
                // adaptiveHeight: true
              });

        });
      });
    }
  });
});
